import React, { useContext, useState } from 'react'
import { Box, Card, Flex, space, TertiaryButton, Text } from '@workday/canvas-kit-react'
import { IncidentPostModel } from '../../models/IncidentPostModel'
import { prettyDate } from '../../models/PrettyDate'
import { attachmentURL, IncidentPostData } from '../../models/IncidentPostData'
import EditIncidentPostForm from './EditIncidentPostForm'
import { editIcon, trashIcon } from '@workday/canvas-system-icons-web'
import { PPHyperlink } from '../../components'
import { UpdateConfirmationContext } from '../../utils/UpdateConfirmationContext'
import { PPLinkify } from '../../components/PPLinkify'

export interface IncidentPostCardProps {
  timeZone: string
  canEditPost: boolean
  post: IncidentPostModel
  onSubmit: (incidentPost: IncidentPostData, callback: (success: boolean) => void) => void
  onDelete: (incidentPost: IncidentPostData, callback: (success: boolean) => void) => void
}

const IncidentPostCard = ({ post, canEditPost, timeZone, onSubmit, onDelete }: IncidentPostCardProps) => {
  const updateConfirmation = useContext(UpdateConfirmationContext)
  const [editing, setEditing] = useState(false)
  return (
    <Card key={post.recordID} padding={space.s} depth="none" position="relative">
      {editing ? (
        <EditIncidentPostForm
          incidentPost={post.toMutableData()}
          onSubmit={onSubmit}
          onCancel={() => setEditing(false)}
        />
      ) : (
        <Box>
          {canEditPost && (
            <Flex position="absolute" right={space.xxs} top={space.xxs} flexDirection="row">
              <TertiaryButton icon={editIcon} onClick={event => setEditing(true)} />
              <TertiaryButton
                icon={trashIcon}
                onClick={event => {
                  updateConfirmation.setConfirmation({
                    title: '',
                    message: `Are you sure you want to delete the post?`,
                    onCancel: () => {},
                    onConfirm: () => {
                      onDelete(post.toMutableData(), success => {})
                    }
                  })
                }}
              />
            </Flex>
          )}
          <Flex flexDirection="column" gap={space.xs}>
            <Text typeLevel="subtext.large" fontWeight="bold">
              {prettyDate(post.recordCreatedDateTime, timeZone, true, true)}
            </Text>
            {post.message && (
              <Text whiteSpace="pre-line" typeLevel="body.small">
                <PPLinkify>{post.message}</PPLinkify>
              </Text>
            )}
            {post.attachments.length > 0 && (
              <Flex flexDirection="row" gap={space.xs} flexWrap="wrap">
                {post.attachments.map(attachment => (
                  <img
                    src={attachmentURL(attachment.file, attachment.type, 0, 200)}
                    srcSet={`${attachmentURL(attachment.file, attachment.type, 0, 400)} 2x`}
                    alt="Photo"
                    style={{
                      borderRadius: '8px',
                      height: '200px'
                    }}
                  />
                ))}
              </Flex>
            )}
          </Flex>
        </Box>
      )}
    </Card>
  )
}

export default IncidentPostCard
